//@flow
import React from 'react';
import { PortalWithState, PortalFunctionParams } from 'react-portal';
const debug = require('../debug/debug')('wc:common:Portal');
export type PortalProps = {
  children: React.ReactNode,
  preventEvent?: string | null,
  node?: Element | null,
  defaultOpen?: boolean,
  openByClickOn?: React.ReactElement,
  closeOnEsc?: boolean,
  closeOnOutsideClick?: boolean,
  onOpen?: () => void,
  onClose?: () => void,
};
export default class Portal extends React.Component<PortalProps> {
  portalId: number;
  static portalCounter: number = 0;
  constructor(props: PortalProps) {
    super(props);
    this.portalId = Portal.portalCounter++;
  }

  componentDidMount() {
    const {preventEvent} = this.props;
    if(preventEvent && preventEvent.length) {
      document.addEventListener(`${preventEvent}`, this.preventWindowEvent);
    }
  }

  componentWillUnmount() {
    const {preventEvent} = this.props;
    if(preventEvent && preventEvent.length) {
      document.removeEventListener(`${preventEvent}`, this.preventWindowEvent);
    }
  }

  preventWindowEvent = (e: Event)=>{
    e.preventDefault();
  }

  getChilder = (params: PortalFunctionParams) => {
    return params ? params.portal(this.props.children) : undefined;
  };

  onClose = () => {
    if (debug.enabled) {
      debug('[onClose()] OnClose Trigerred Portal Id:', this.portalId);
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onOpen = () => {
    if (debug.enabled) {
      debug('[onOpen()] OnOpen. Trigerred Portal Id:', this.portalId);
    }
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  render() {
    //const { children } = this.props;
    return (
      <PortalWithState
        closeOnEsc={this.props.closeOnEsc}
        //closeOnOutsideClick={this.props.closeOnOutsideClick}
        onClose={this.onClose}
        onOpen={this.onOpen}
        defaultOpen={this.props.defaultOpen}>
        {this.getChilder}
      </PortalWithState>
    );
  }
}
